import { StaggerTestimonials } from '@/components/ui/stagger-testimonials';

const testimonials = [
  {
    quote: "BitNinja transformed our digital presence completely. Their team delivered a stunning website that increased our conversions by 150%. The attention to detail and technical expertise is unmatched.",
    name: "Sarah Johnson",
    role: "CEO at TechStart Inc.",
    image: "https://i.pravatar.cc/150?img=47",
  },
  {
    quote: "Working with BitNinja was an absolute pleasure. They understood our vision from day one and delivered a mobile app that our users love. The project was completed on time and within budget.",
    name: "Michael Chen",
    role: "Founder at InnovateLab",
    image: "https://i.pravatar.cc/150?img=11",
  },
  {
    quote: "The digital marketing strategies implemented by BitNinja helped us achieve a 300% ROI in just 6 months. Their data-driven approach and creative solutions are truly exceptional.",
    name: "Emily Rodriguez",
    role: "Marketing Director at GrowthSphere",
    image: "https://i.pravatar.cc/150?img=5",
  },
  {
    quote: "BitNinja cloud migration services saved us thousands in infrastructure costs while improving performance. Their technical team is knowledgeable, responsive, and always goes the extra mile.",
    name: "David Park",
    role: "CTO at DataFlow Systems",
    image: "https://i.pravatar.cc/150?img=15",
  },
  {
    quote: "The UI/UX design work by BitNinja exceeded all expectations. They created an intuitive interface that our users find delightful. User engagement increased by 80% after the redesign.",
    name: "Amanda Foster",
    role: "Product Manager at DesignHub",
    image: "https://i.pravatar.cc/150?img=9",
  },
  {
    quote: "Outstanding work on our fintech platform! BitNinja delivered a secure, scalable solution that handles millions of transactions. Their expertise in financial technology is remarkable.",
    name: "James Wilson",
    role: "Director at FinancePro",
    image: "https://i.pravatar.cc/150?img=52",
  },
];

const TestimonialsSection = () => {
  const stats = [
    { value: '30+', label: 'Happy Clients' },
    { value: '98%', label: 'Client Satisfaction' },
    { value: '4.9', label: 'Average Rating' },
    { value: '50+', label: 'Projects Delivered' },
  ];

  return (
    <section id="testimonials" className="relative w-full bg-background-100 border-t border-background-200 overflow-hidden py-14 md:py-16">
      <div className="section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="inline-flex w-6 h-6 items-center justify-center bg-foreground-900 text-background-50 rounded-sm">
                <i className="ri-chat-quote-line text-xs"></i>
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-600">
                06 / Client Feedback
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight text-foreground-900">
              What Our Clients{' '}
              <span className="block text-primary-500">Say About Us.</span>
            </h2>
          </div>

          <StaggerTestimonials testimonials={testimonials} />

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 md:mt-20">
            {stats.map((stat, index) => (
              <div key={index} className="text-center p-6 bg-background-50 rounded-2xl border border-background-200 transition-all duration-300 hover:-translate-y-1">
                <div className="font-display text-3xl md:text-4xl font-bold text-primary-500 mb-2">{stat.value}</div>
                <div className="text-foreground-600 text-sm font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
